import { render, staticRenderFns } from "./TeamLeadsList.vue?vue&type=template&id=cfb58230&scoped=true"
import script from "./TeamLeadsList.vue?vue&type=script&lang=js"
export * from "./TeamLeadsList.vue?vue&type=script&lang=js"
import style0 from "./TeamLeadsList.vue?vue&type=style&index=0&id=cfb58230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb58230",
  null
  
)

export default component.exports